import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Title from '../../components/Title.js';
import StepProgressBar from '../../components/StepProgressBar.js';
import IconStatus from '../../components/icons/IconStatus.js';
import { getWords } from '../../utils/get-words.js';

const BudgetOperationTopPart2 = ReactRouterDOM.withRouter(function ({ budgetOperation }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);

  return (
    <div>
      <div>
        <div className="p-1 bg-gray-lighter">
          <Title level={2} icon={IconStatus} color="blue" label={words.status} />
        </div>
        <div className="d-flex align-items-center justify-content-end">
        </div>
        <StepProgressBar
          value={budgetOperation.status}
          dataSource={[['inRevision', words.inRevision], ['confirmed', words.confirmed], ['sent', words.sent]]}
          colors={{ inRevision: 'red', confirmed: 'gold', sent: 'green' }}
        />
      </div>
    </div>
  );
})

export default BudgetOperationTopPart2;
